export default __webpack_public_path__ + "42327c0bf034294d35581446c86cd45a.png";